import React, { createContext, useState, useEffect, ReactNode, Context } from 'react'

interface AuthContextType {
  isLoggedIn: boolean
  login: () => void
  logout: () => void
  token: string | null
}

const AuthContext: Context<AuthContextType> = createContext<AuthContextType>({} as AuthContextType)

interface AuthProviderProps {
  children: ReactNode
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [token, setToken] = useState<string | null>(null)

  useEffect(() => {
    const storedToken = localStorage.getItem('token')
    setToken(storedToken || null)
    setIsLoggedIn(!!storedToken)
  }, [])

  // Wenn der Axios-Client den Refresh nicht retten kann, wirft er dieses Event
  useEffect(() => {
    const onForceLogout = () => handleLogout(false)
    window.addEventListener('auth:logout', onForceLogout)
    return () => window.removeEventListener('auth:logout', onForceLogout)
  }, [])

  const handleLogin = () => {
    const storedToken = localStorage.getItem('token')
    setToken(storedToken)
    setIsLoggedIn(true)
  }

  const handleLogout = (callBackend = true) => {
    localStorage.removeItem('token')
    setToken(null)
    setIsLoggedIn(false)
    if (callBackend) {
      fetch('/api/auth/logout', { method: 'POST', credentials: 'include' }).catch(() => {})
    }
  }

  return (
    <AuthContext.Provider value={{ isLoggedIn, login: handleLogin, logout: handleLogout, token }}>
      {children}
    </AuthContext.Provider>
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export const useAuth = () => React.useContext(AuthContext)
